import { FC } from 'react'

import { Translation } from 'cng-common/features/translations'
import { IAssortmentItem } from 'partner360/features/assortment/models/data/IAssortmentItem'

import { TRANSLATION_KEYS } from '../../../../translations'
import { MultipleFields } from '../multipleFields/MultipleFields'

import styles from './Comments.module.scss'

interface ICommentsProps {
  isEditMode: boolean
  item: IAssortmentItem
  labelKey: string
}

export const Comments: FC<ICommentsProps> = ({ isEditMode, item, labelKey }) => {
  return (
    <div className={styles.root}>
      <div className={styles.readLabel}>
        <Translation text={labelKey} />
      </div>
      <MultipleFields
        isEditMode={isEditMode}
        item={item}
        field="Comments"
        placeholderTranslationKey={TRANSLATION_KEYS.item.commentsPlaceholder}
      />
    </div>
  )
}
